/**
 * Meeting Bottom Bar Component
 * 하단 고정 참여바 (모바일 전용)
 */

import { Button } from "@/components/ui/button";
import { Calendar, Heart, MessageCircle, Users } from "lucide-react";

interface MeetingBottomBarProps {
  isFavorite: boolean;
  isJoined: boolean;
  onFavoriteToggle: () => void;
  onJoinMeeting?: () => void;
  ageRange?: string | null;
}

export function MeetingBottomBar({
  isFavorite,
  isJoined,
  onFavoriteToggle,
  onJoinMeeting,
  ageRange,
}: MeetingBottomBarProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t p-4 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center gap-3">
        <Button
          variant="outline"
          size="icon"
          onClick={onFavoriteToggle}
          className="flex-shrink-0"
        >
          <Heart
            className={`w-5 h-5 ${
              isFavorite ? "fill-red-500 text-red-500" : ""
            }`}
          />
        </Button>
        <Button variant="outline" className="flex-1">
          <MessageCircle className="w-4 h-4 mr-2" />
          DM
        </Button>
        <div className="flex flex-1 flex-col gap-1">
          {!isJoined && ageRange && (
            <p className="text-xs text-muted-foreground text-center">
              권장 나이대 {ageRange}
            </p>
          )}
          {isJoined ? (
            <Button className="flex-1" variant="secondary">
              <Calendar className="w-4 h-4 mr-2" />
              참여 중
            </Button>
          ) : (
            <Button className="flex-1" onClick={onJoinMeeting}>
              <Users className="w-4 h-4 mr-2" />
              참여하기
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
